import {
  GET_USER_DATA,
  SET_USER_DATA,
  SET_LOGO,
  SET_USAGE,
  SET_ORGANIZATION,
  SET_TOLLFREE_NUMBER,
  SET_TOLLFREE_NUMBER_STATUS,
  SET_TOLLFREE_NUMBER_PURCHASED,
  SET_CARD_EXPIRED,
} from "./AppUserDataTypes";

const initialState = {
  appUserData: {},
  logoURL: "",
  logoData: "",
  smsCredits: {},
  organizationDetails: {},
  tollfreeNumber: null,
  tollFreeNumberStatus: null,
  isTollfreeNumberPurchased: false,
  isCardExpired: false,
};

const AppUserDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_DATA:
      return {
        ...state,
      };

    case SET_LOGO:
      return {
        ...state,
        logoData: action.payload,
      };
    case SET_USAGE:
      return {
        ...state,
        smsCredits: action.payload,
      };
    case SET_ORGANIZATION:
      return {
        ...state,
        organizationDetails: action.payload,
      };
    case SET_TOLLFREE_NUMBER:
      return {
        ...state,
        tollfreeNumber: action.payload,
      };
    case SET_TOLLFREE_NUMBER_STATUS:
      return {
        ...state,
        tollFreeNumberStatus: action.payload,
      };
    case SET_TOLLFREE_NUMBER_PURCHASED:
      return {
        ...state,
        isTollfreeNumberPurchased: action.payload,
      };
    case SET_CARD_EXPIRED:
      return {
        ...state,
        isCardExpired: action.payload,
      };
    case SET_USER_DATA:
      return {
        ...state,
        appUserData: action.payload,
        logoURL: action.payload.logo,
        smsCredits: action.payload.smsCredits,
        organizationDetails: action.payload.organizationDetails,
        tollFreeNumberStatus: action.payload.tollFreeNumberStatus,
        tollfreeNumber: action.payload.tollfreeNumber,
        isTollfreeNumberPurchased: action.payload.isTollfreeNumberPurchased,
        isCardExpired: action.payload.isCardExpired,
      };
    default:
      return state;
  }
};

export default AppUserDataReducer;
